import { render, staticRenderFns } from "./Uebersicht.vue?vue&type=template&id=4b9096d5&scoped=true"
import script from "./Uebersicht.vue?vue&type=script&lang=js"
export * from "./Uebersicht.vue?vue&type=script&lang=js"
import style0 from "./Uebersicht.vue?vue&type=style&index=0&id=4b9096d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9096d5",
  null
  
)

export default component.exports